export const HOME = "/";
export const SETTINGS = "/settings";
export const TOURS = "/tours";
export const AUTH = "/auth";
export const FORBIDDEN = "/forbidden";
export const NOT_FOUND = "/*";

export const HOME_NAME = "HOME";
export const SETTINGS_NAME = "SETTINGS";
export const TOURS_NAME = "TOURS";
export const AUTH_NAME = "AUTH";
export const FORBIDDEN_NAME = "FORBIDDEN";
export const NOT_FOUND_NAME = "NOT_FOUND";
